import { Injectable } from '@angular/core';

export class Pipe {
  bends: number = 0;
  flexible: boolean = false;
  id?: string;
  length: number = 0;
  parallel: number = 1;
  section: string = "Circular";
  type?: string;
  xdim1: number = 0;
  xdim2: number = 0;
  selected?: boolean;
  entrance?: boolean = false;

  constructor(id?:string){
    this.id = id?id:null;
    this.selected=false;
    this.bends = 0.0;
    this.flexible = false;
    this.length = 0.0;
    this.parallel = 1.0;
    this.section = "Circular";
    this.xdim1 = 0.0;
    this.xdim2 = 0.0;
    this.entrance= false;
  }
}

export class Gas {
  id: string;
  index: number;
  name:string;
}

@Injectable({
  providedIn: 'root'
})
export class DatatypesService {
  constructor() { }
}
